import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Dialog } from '@material-ui/core'

import { GetTos, GetCopyright, GetPrivacy, dateObj, koPrivacyTable, GetAi } from '@/utils/TosContents'

import CloseButton from '@/Common/CloseButton'

import './index.scss'
import i18n from '../../../i18n'

class TosDialog extends Component {
    koDialogHeading = {
        'privacy': '개인정보 수집 및 이용동의 (필수)',
        'resale': '서비스 재판매 금지에 대한 동의 (필수)',
        'ai': 'AI약관 동의 (필수)',
        'collect': '선택정보 수집 및 이용동의 (선택)'
    }

    renderTable = (obj) => {
        const tableHeader = [...obj.header]
        const tableBody = [...obj.body]
        return (
            <div className='table-area'>
                <table>
                    <thead>
                        <tr>{tableHeader.map((item) => <th>{item}</th>)}</tr>
                    </thead>
                    <tbody>
                        {tableBody.map((item) => {
                            return (
                                <tr>{Object.keys(item).map((key) => <td rowSpan={item[key].rowSpan}>{item[key].text}</td>)}</tr>
                            )
                        })}
                    </tbody>
                </table>
                { obj.text && <div className='table-bottom-text'>{obj.text}</div>}
            </div>
        )
    }

    renderContent = (tosDialogContent, active = false) => {
        const { lang } = this.props
        const date = lang === 'ko' ? dateObj.third : dateObj.second

        const tosContents = GetTos(lang, dateObj.fifth)
        const privacyContents = GetPrivacy(lang, date)
        const copyrightContents = GetCopyright(lang, dateObj.second)
        const aiContents = GetAi(lang, dateObj.fourth)

        if (tosDialogContent === 'tos') return (
            <div className="content-wrapper">
                <div className="heading">{tosContents.header}</div>
                <div className={`contents ${active && 'active'}`}>
                    {tosContents.body.map(item => (
                        <>
                            <div className="title">{item.title}</div>
                            {item.body.map(content => <div className="content">{content}</div>)}
                        </>
                    ))}
                    <div className="title">{tosContents.footer}</div>
                    <div className="content">{tosContents.footerSub}</div>
                </div>
            </div>
        )
        else if (tosDialogContent === 'privacy') {
            if (lang === 'ko') return (
                <div className="content-wrapper">
                    <div className="heading">{this.koDialogHeading[tosDialogContent]}</div>
                    <div className={`contents ${active && 'active'}`}>{this.renderTable(koPrivacyTable.required)}</div>
                </div>
            )
            else return (
                <div className="content-wrapper">
                    <div className="heading">{privacyContents.header}</div>
                    <div className={`contents ${active && 'active'}`}>
                        {
                            privacyContents.headerSub &&
                            <div className="content">{privacyContents.headerSub}</div>
                        }
                        {privacyContents.body.map(item => (
                            <>
                                <div className="title">{item.title}</div>
                                {item.body.map(content => <div className="content">{content}</div>)}
                            </>
                        ))}
                        <div className="title">{privacyContents.footer}</div>
                        <div className="content">{privacyContents.footerSub}</div>
                    </div>
                </div>
            )
        }
        else if (tosDialogContent === 'resale' || tosDialogContent === 'copyright') return (
            <div className="content-wrapper">
                <div className="heading">{tosDialogContent === 'resale' ? this.koDialogHeading[tosDialogContent] : copyrightContents.header}</div>
                <div className={`contents ${active && 'active'}`}>
                    {
                        copyrightContents.headerSub &&
                        <div className="content">{copyrightContents.headerSub}</div>
                    }
                    {copyrightContents.body.map(item => (
                        <>
                            <div className="title">{item.title}</div>
                            {item.body.map(content => <div className="content">{content}</div>)}
                        </>
                    ))}
                </div>
            </div>
        )
		else if (tosDialogContent === 'ai') return (
			<div className="content-wrapper">
                <div className="heading">{aiContents.header}</div>
                <div className={`contents ${active && 'active'}`}>
                    {aiContents.body.map(item => (
                        <>
                            <div className="title">{item.title}</div>
                            {item.body.map(content => <div className="content">{content}</div>)}
                        </>
                    ))}
                    <div className="content">{aiContents.footerSub}</div>
                    <div className="content">{aiContents.footerSub2}</div>
                </div>
            </div>
		)
        else if (tosDialogContent === 'collect') return (
            <div className="content-wrapper">
                <div className="heading">{this.koDialogHeading[tosDialogContent]}</div>
                <div className={`contents ${active && 'active'}`}>{this.renderTable(koPrivacyTable.optional)}</div>
            </div>
        )
    }

    render() {
        const { open, onClose, lang, tosDialogContent } = this.props
        return (
            <Dialog open={open} onClose={onClose} maxWidth="xl" >
                <div className="tos-dialog-root-container">
                    <div className="close-btn" onClick={onClose}>
                        <CloseButton />
                    </div>
                    {
                        tosDialogContent
                            ?
                            this.renderContent(tosDialogContent, true)
                            :
                            <>
                                {this.renderContent('tos')}
                                {this.renderContent('privacy')}
                                {this.renderContent(lang === 'ko' ? 'resale' : 'copyright')}
                                {this.renderContent('ai')}
                                { lang === 'ko' && this.renderContent('collect')}
                            </>
                    }
                    <div className="tos-agree-button" onClick={onClose}>
                        {i18n.t("global.confirm")}
                    </div>
                </div>
            </Dialog>
        )
    }
}

const mapStateToProps = state => ({
    lang: state.langStore.lang
})

export default connect(mapStateToProps, null)(TosDialog)